import { render, staticRenderFns } from "./simpleCreate.vue?vue&type=template&id=1c6e3217&scoped=true"
import script from "./simpleCreate.vue?vue&type=script&lang=js"
export * from "./simpleCreate.vue?vue&type=script&lang=js"
import style0 from "./simpleCreate.vue?vue&type=style&index=0&id=1c6e3217&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6e3217",
  null
  
)

export default component.exports